import React from 'react';
import { Download, X } from 'lucide-react';
import { useAppUpdate } from '../../hooks/useAppUpdate';
import '../../styles/app-update-banner.css';

/**
 * Dismissible top banner shown on Android native when Google Play reports a
 * newer version is available. Tapping Update starts a flexible in-app update.
 *
 * TODO(iOS): This component is Android-only. A future iOS version should use
 * an iOS-specific update hook and prompt.
 */
function AppUpdateBanner() {
  const {
    showBanner,
    availableVersionCode,
    isUpdating,
    startUpdate,
    dismiss,
  } = useAppUpdate();

  if (!showBanner) {
    return null;
  }

  return (
    <div className="app-update-banner" role="status" aria-live="polite">
      <Download
        size={18}
        className="app-update-banner__icon"
        aria-hidden="true"
      />
      <span className="app-update-banner__message">
        A newer version of Pista is available
        {availableVersionCode ? ` (version code ${availableVersionCode})` : ''}.
        Update now for the latest improvements.
      </span>
      <button
        type="button"
        className="app-update-banner__cta"
        onClick={startUpdate}
        disabled={isUpdating}
      >
        {isUpdating ? 'Opening…' : 'Update'}
      </button>
      <button
        type="button"
        className="app-update-banner__close"
        onClick={dismiss}
        aria-label="Dismiss update banner"
      >
        <X size={16} aria-hidden="true" />
      </button>
    </div>
  );
}

export default AppUpdateBanner;
